export default "__VITE_ASSET__B5kjao3P__"